import { Fragment, useContext, useEffect, useState } from "react";
import $ from "jquery";
import Skeleton from "react-loading-skeleton";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { smsNumberChangeClick, SmsNumberStart04, smsNumberUpdateClick } from "../../../../Layout/Common/common";
import { useAuth } from "../../../../Context/AuthContext";
import { axiosInstance } from "../../../../axios/axiosInstance";
import { useFlashLoaderLoader } from "../../../../Context/FlashScreenContext";
import { SHIPPING_METHOD } from "../../../../constants";

export const NotificationNumber = () => {
  const {
    smsNumber,
    deliveryMethod,
    CartItem,
    shippingAddress,
    setSmsNumber,
    setShippingAddress,
    smsNotificationCancelClicked,
    smsEditInProgress,
  } = useContext(GlobalContext);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isSaved, setIsSaved] = useState(true);
  const { isAuthenticated, userId } = useAuth();
  const { showLoader, hideLoader } = useFlashLoaderLoader();
  const [updateClicked, setUpdateClicked] = useState(null);
  useEffect(() => {
    if (smsNumber != null) {
      if (smsNumber == "" && updateClicked != true) smsNumberChangeClick();
      else {
        smsNumberUpdateClick();
      }
      setMobileNumber(smsNumber);
    }
    return () => {
      setUpdateClicked(null);
    };
  }, [smsNumber]);

  useEffect(() => {
    return () => {
      smsEditInProgress.current = false;
    };
  }, []);

  const hanldeNumberChange = (e) => {
    var value = e.target.value;
    smsEditInProgress.current = true;
    setMobileNumber(SmsNumberStart04(value));
  };

  const removeMobileNumber = () => {
    updateNumber("");
  };

  const handleUpdateNumber = () => {
    updateNumber(mobileNumber);
    smsNumberUpdateClick();
  };
  const updateNumber = async (num) => {
    // await showLoader();
    setUpdateClicked(true);
    smsEditInProgress.current = false;
    if (String(num) === "") smsNotificationCancelClicked.current = true;
    else smsNotificationCancelClicked.current = false;
    var params = {
      mobileno: String(num ? num : ""),
      IsSave: isSaved,
      userId: String(userId),
      orderId: String(CartItem.orderid),
    };
    axiosInstance
      .post("Shipping/UpdateMobileNumber", params)
      .then((response) => {
        setMobileNumber(num);
        setSmsNumber(num);
        if (shippingAddress && shippingAddress.shipPhone) {
          setShippingAddress((prevState) => ({
            ...prevState,
            shipPhone: num,
          }));
        }
        hideLoader();
      })
      .catch((error) => {
        console.error(error.message);
        hideLoader();
      });
  };

  const handleCancelClick = () => {
    smsEditInProgress.current = false;
    setMobileNumber(smsNumber);
    smsNumberUpdateClick();
    smsNotificationCancelClicked.current = true;
  };

  return (
    <Fragment>
      {smsNumber != null && (
        <div className="checkout-infoDetails">
          <h3>SMS Order Ready Notification</h3>
          <div className="checkout-border-content">
            <div className="sms-sent-notify">
              {mobileNumber == "" ? (
                "SMS Order ready notification will NOT be sent."
              ) : (
                <p>
                  Order Ready SMS message will be sent to:
                  <b>{mobileNumber}</b>
                </p>
              )}
              <div className="button-effect sms-notify-btn" style={{ display: "flex", gap: "10px" }}>
                <button onClick={smsNumberChangeClick} className="btn btn-products btn-addcart" id="change-sms-notify">
                  {mobileNumber == "" ? "Add" : "Change"}
                </button>
                {mobileNumber != "" && (
                  <button
                    onClick={removeMobileNumber}
                    className="btn btn-products btn-unavailable"
                    id="remove-sms-notify"
                    style={{ color: "#000", fontWeight: "unset" }}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>

            <div className="changing-sms-notify">
              <p>Get notified as soon as your order is ready for Pick Up.</p>
              <form>
                <div className="update-sms-notify">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Number"
                    id="textbox-sms-notify"
                    value={mobileNumber}
                    onChange={hanldeNumberChange}
                  />
                  <div className="button-effect update-smsNotify">
                    <button
                      type="button"
                      className="btn btn-products btn-addcart"
                      id="update-sms-notify"
                      onClick={handleUpdateNumber}
                      disabled={!(mobileNumber && mobileNumber != "" && String(mobileNumber).length == 10)}
                    >
                      Update
                    </button>
                  </div>
                  <div className="button-effect update-smsNotify">
                    <button
                      type="button"
                      className="btn btn-products btn-unavailable"
                      id="cancel-sms-notify"
                      style={{ color: "#000", fontWeight: "unset" }}
                      onClick={handleCancelClick}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div className="form-check custom-check feature-order mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="savefuture-order"
                    checked={isSaved}
                    onChange={() => {
                      setIsSaved((prev) => !prev);
                    }}
                  />
                  <label className="form-check-label" htmlFor="savefuture-order" style={{ width: "fit-content" }}>
                    Save Number for future order
                  </label>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
